//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { TrackingIdPrefix } from '@models/TrackingId';

export const DropboxTrackingIdPrefix: TrackingIdPrefix =
  'dropbox-';

export const DropboxTrackingIds = {
  IMPORT_FROM_DROPBOX: `${DropboxTrackingIdPrefix}import-from-dropbox`,
} as const;

export type DropboxLinkType = 'direct' | 'preview'

export const DROPBOX_SDK_URL = 'https://www.dropbox.com/static/api/2/dropins.js'
export const DROPBOX_SCRIPT_ID = 'dropboxjs'
